import usePeopleListActions from "./usePeopleListActions";

export default function usePeopleServiceManager() {
	const peopleListActions = usePeopleListActions();

	const run = () => Promise.all([peopleListActions.load()]);

	return {
		run
	};
}
